'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var Loads = require('react-loads');
var TyroHealthDarkLogo = require('@medipass/assets/images/Tyro/dark.png');
var sdk = require('@medipass/web-sdk');
var WithTitle = require('../WithTitle.js');
require('react-document-title');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Loads__default = /*#__PURE__*/_interopDefaultLegacy(Loads);
var TyroHealthDarkLogo__default = /*#__PURE__*/_interopDefaultLegacy(TyroHealthDarkLogo);
var sdk__default = /*#__PURE__*/_interopDefaultLegacy(sdk);

var _templateObject, _templateObject2, _templateObject3;
var Container = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-left: 10px;\n  padding-right: 10px;\n  @media screen and (max-width: 767px) {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n"])));
var ContentWrapper = bumbag.styled(bumbag.Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  margin-top: ", ";\n\n  @media screen and (max-width: 767px) {\n    margin-top: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n  }\n\n  & > div {\n    width: 100%;\n  }\n"])), function (_ref) {
  var description = _ref.description;
  return description ? '0px' : '30px';
}, function (_ref2) {
  var description = _ref2.description;
  return description ? '0px' : '20px';
}, function (_ref3) {
  var isWide = _ref3.isWide;
  return isWide ? '1200px' : '768px';
}, function (_ref4) {
  var isWide = _ref4.isWide;
  return isWide ? '1200px' : '600px';
});
var DescriptionText = bumbag.styled(bumbag.Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose__default["default"](["\n  margin-top: 40px;\n  margin-bottom: 40px;\n  max-width: 600px;\n\n  @media screen and (max-width: 767px) {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"])));

var Page = /*#__PURE__*/function (_Component) {
  _inheritsLoose__default["default"](Page, _Component);

  function Page() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "render", function () {
      var _this$props = _this.props,
          accountBenefitsComponent = _this$props.accountBenefitsComponent,
          children = _this$props.children,
          description = _this$props.description,
          isWide = _this$props.isWide,
          title = _this$props.title;
      return /*#__PURE__*/React__default["default"].createElement(WithTitle["default"], {
        title: title
      }, /*#__PURE__*/React__default["default"].createElement(Loads__default["default"], {
        loadOnMount: true,
        delay: 0,
        load: function load() {
          return sdk__default["default"].applicationUtils.getSelfApplicationCached();
        },
        loadPolicy: "cache-first"
      }, function (_ref5) {
        var application = _ref5.response;
        return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
          className: "hero is-fullheight"
        }, /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement("img", {
          src: TyroHealthDarkLogo__default["default"],
          className: "mt-7 w-64 sm:mt-12",
          alt: "Tyro Health Online"
        }), description && /*#__PURE__*/React__default["default"].createElement(DescriptionText, {
          className: "has-text-centered"
        }, description), /*#__PURE__*/React__default["default"].createElement(ContentWrapper, {
          description: description,
          isWide: isWide
        }, children), accountBenefitsComponent &&
        /*#__PURE__*/
        // @ts-expect-error TS(2322): Type '{ children: ReactElement<any, string | JSXEl... Remove this comment to see the full error message
        React__default["default"].createElement(ContentWrapper, {
          isWide: isWide
        }, accountBenefitsComponent), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
          textAlign: "center",
          marginTop: "major-3"
        }, /*#__PURE__*/React__default["default"].createElement("b", null, new Date().getFullYear(), " \xA9 Tyro Health"), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
          href: application ? application.termsUrl : 'https://www.tyrohealth.com/terms-conditions/',
          target: "_blank",
          rel: "noopener noreferrer"
        }, "User terms"), ' | ', /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
          href: application ? application.privacyUrl : 'https://www.tyrohealth.com/privacy/',
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Privacy Policy")))));
      }));
    });

    return _this;
  }

  return Page;
}(React.Component);

_defineProperty__default["default"](Page, "defaultProps", {
  accountBenefitsComponent: undefined,
  description: null,
  isWide: false,
  title: null
});

exports["default"] = Page;
